import { Component, Input } from '@angular/core';
import { NearbyPlace } from '../landing-page.models';

@Component({
  selector: 'app-nearby-section',
  templateUrl: './nearby-section.component.html',
  styleUrls: ['./nearby-section.component.scss'],
  standalone: false
})
export class NearbySectionComponent {
  @Input() places: NearbyPlace[] = [];

  balancedColumns(maxColumns: number): number {
    const count = this.places.length;
    return count ? Math.ceil(count / Math.ceil(count / maxColumns)) : 1;
  }

  walkingMinutes(walkingTime: string): number | null {
    const value = walkingTime?.trim() ?? '';
    const seconds = /^(\d+(?:[.,]\d+)?)\s*s$/i.exec(value);
    if (seconds) {
      return Math.max(1, Math.ceil(Number(seconds[1].replace(',', '.')) / 60));
    }

    const minutes = /\d+/.exec(value);
    return minutes ? Number(minutes[0]) : null;
  }
}
